export default function Newsletter() {
  return (
    <>
      <section className="demo py-10 xl:py-20">
        <div className="max-width">
          <h4 className="text-4xl text-white text-center mb-5 xl:mb-10">
            Subscribe to our newsletter
          </h4>
          <form className="lg:max-w-5xl lg:mx-auto px-5 2xl:px-0 flex flex-col lg:w-1/2">
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              required
              className="py-3 px-5 bg-transparent placeholder-white input-border"
            />
            <small className="text-gray-200 block my-5">
              No spam. Cancel anytime.
            </small>
            <button className="btn-light">Subscribe</button>
          </form>
        </div>
      </section>
    </>
  )
}
